/**
 * Created by evgenijsenkevic on 28.08.2024
 * */

const EditorLocationScene = cc.Scene.extend({
    ctor: function (locationId) {
        if (locationId) {
            const bundleId = `location_${locationId}`;
            if (!bundles[bundleId]) {
                throw new Error(`no bundle ${bundleId}`);
            }

            locationId = bundles[bundleId].meta.location;
            cleverapps.meta.getLocationMeta(locationId).locationConfig.locationBundleId = bundleId;
            cleverapps.meta.switchLocation(locationId);
        }

        this._super();

        this.location = cleverapps.meta.getSelectedLocation();

        this.sceneComponent = ComponentMap.attach(this, new SceneComponent({
            styling: this.getBackgroundStyles(),
            bundles: this.listBundles(),
            lazyBundles: this.lazyBundles(),
            sceneName: cleverapps.Environment.SCENE_EDITOR
        }));
    },

    destructor: function () {
        this.editor.destructor();
        this.editor.map.stop();

        if (["merge", "farm"].includes(cleverapps.config.type)) {
            Map2dLocation.currentLocation = undefined;
        }
    },

    onSceneLoaded: function () {
        connector.ads.closeStickyCallback();
        cleverapps.resolution.setContainerPadding();

        cleverapps.skins.update();

        cleverapps.administrator.adminLocations.setActive(new AdminLocation(this.location.locationConfig.locationBundleId));

        if (["merge", "farm"].includes(cleverapps.config.type)) {
            const merge = new Map2dLocation();
            merge.stop();

            this.editor = new Map2dEditor(this.location, MergeOrangery);

            merge.map = this.editor.map;
        } else {
            this.editor = new Map2dEditor(this.location, HomefixOrangery);
        }

        const editorView = new Map2dEditorView(this.editor);
        this.addChild(editorView);

        const orangery = Editor.currentEditor.orangery;
        if (orangery) {
            const control = new cc.Node();
            control.addChild(new OrangeryView(orangery));
            this.addChild(control);

            ComponentMap.attach(control, new HidingComponent({
                direction: cleverapps.UI.VERTICAL,
                control: orangery.getControlName()
            }));
        }

        ComponentUtils.findComponentByName(this, "UpMenuController").getControlButtons().forEach((button) => {
            button.passBlocked = true;
        });

        const scrollView = this.editor.map.scroller.getScrollView();
        if (scrollView) {
            scrollView.passBlocked = true;
        }
    },

    onCloseAction: function () {
        cleverapps.setUrlHash({
            mode: undefined,
            location: undefined
        });

        if (cleverapps.config.adminMode) {
            cleverapps.config.editorMode = false;
            AdminLocationsScene.open();
            return true;
        }
    },

    getBackgroundStyles: function (...args) {
        if (["merge", "farm"].includes(cleverapps.config.type)) {
            return cleverapps.skins.getSlot("gameSceneBg") || cleverapps.styles.Map2dLocationScene.backgroundStyles;
        }
        return HomefixSceneComponent.prototype.getBackgroundStyles.call(this, ...args);
    },

    listBundles: function () {
        const locationId = this.location.locationId;
        const locationConfig = cleverapps.meta.getLocationMeta(locationId).locationConfig;
        const names = ["editor"].concat(
            Map2dEditor.BUNDLES,
            [
                locationConfig.locationBundleId,
                Map2d.getTilesTexture(bundles[locationConfig.locationBundleId].meta.tiles || locationId),
                Map2d.getUnitsTexture(bundles[locationConfig.locationBundleId].meta.units || locationId),
                `quests_${locationId}`,
                `quests_${bundles[locationConfig.locationBundleId].meta.units || locationId}`,
                `unitstories_${locationId}`,
                Map2d.getCustomUnitsTexture(),
                Map2d.getBackgroundBundles(locationId)
            ]
        );

        return names.filter((bundleName) => bundles[bundleName]);
    },

    lazyBundles: function () {
        let result = [];

        if (["merge", "farm"].includes(cleverapps.config.type)) {
            result = result.concat(Families.listLazyBundles(Object.keys(this.location.families)));
        }

        return result;
    }
});

EditorLocationScene.open = function (f) {
    const params = cleverapps.getRequestParameters(location.hash);
    cleverapps.setUrlHash({ mode: "editor_location" });

    cleverapps.config.editorMode = true;
    cleverapps.config.adminMode = true;

    let locationId = params.location;
    if (cleverapps.isNumber(locationId)) {
        locationId = parseInt(locationId);
    }

    if (f) {
        cleverapps.scenes.replaceScene(new EditorLocationScene(locationId), f);
    } else {
        cleverapps.focusManager.display({
            focus: "EditorLocationSceneOpen",
            action: function (f) {
                cleverapps.scenes.replaceScene(new EditorLocationScene(locationId), f);
            }
        });
    }
};